import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './ReviewsItem.css';
import { ILabel } from '../../types/labels';

export interface IReviewsItemProps {
  id: string;
  aside: React.ReactNode;
  author: React.ReactNode;
  comment: React.ReactNode;
  label?: ILabel | null;
  footer: React.ReactNode;
}

export const ReviewsItem: React.FC<IReviewsItemProps> = props => {
  const { id, aside, author, label, comment, footer } = props;

  return (
    <div data-testid="ReviewItem" className={style['container']} id={id}>
      <Responsive desktop>
        <div className={style['aside']}>{aside}</div>
      </Responsive>
      <div className={style['main']}>
        <div className={style['main-heading']}>
          <Responsive phone tablet>
            <div className={style['aside']}>{aside}</div>
          </Responsive>
          <div className={style['author']}>{author}</div>
          <Responsive desktop>
            {!!label && (
              <div className={style['label']} style={{ backgroundColor: label.color }}>
                {label.text}
              </div>
            )}
          </Responsive>
        </div>
        <div className={style['comment']}>{comment}</div>
        <div className={style['footer']}>{footer}</div>
      </div>
    </div>
  );
};
